export enum NextTask {
    OPEN_NEXT = "openNextTask",
    RETURN_TASK = "returnToTaskList",
}

export type NextTaskKeys = keyof typeof NextTask;

export const NextTaskKeysList: Array<NextTaskKeys> = Object.keys(NextTask) as Array<NextTaskKeys>;


export enum WhenApprovingTask {
    OPEN_COMMENT = "openComment",
    APPROVE_DIRECTLY = "approveDirectly",
}

export type WhenApprovingTaskKeys = keyof typeof WhenApprovingTask;

export const WhenApprovingTaskKeysList: Array<WhenApprovingTaskKeys> = Object.keys(WhenApprovingTask) as Array<WhenApprovingTaskKeys>;


export enum PDFViewer {
    BROWSER_PDF = "browserPDF",
    ALTERNATIVE_PDF = "alternativePDF",
}

export type PDFViewerKeys = keyof typeof PDFViewer;

export const PDFViewerKeysList: Array<PDFViewerKeys> = Object.keys(PDFViewer) as Array<PDFViewerKeys>;


export const ApproverNotification = {
    newTaskForApprover:false,
    taskBlocked: false,
    appointedAsSubstitute: false,
    documentBlocked: false
}

export type ApproverNotificationKeys = keyof typeof ApproverNotification;

export const ApproverNotificationKeysList: Array<ApproverNotificationKeys> = Object.keys(ApproverNotification) as Array<ApproverNotificationKeys>;


export enum SubstituteActivePeriod {
    INACTIVE = "inactive",
    ACTIVE_NOW = "active",
    ACTIVE_PERIOD = "activePeriod",
}

export type SubstituteKeys = keyof typeof SubstituteActivePeriod;

export const SubstituteKeysList: Array<SubstituteKeys> = Object.keys(SubstituteActivePeriod) as Array<SubstituteKeys>;
